"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AppTheme", {
  enumerable: true,
  get: function get() {
    return _AppTheme.default;
  }
});
Object.defineProperty(exports, "SystemIcon", {
  enumerable: true,
  get: function get() {
    return _SystemIcon.default;
  }
});
Object.defineProperty(exports, "MidRendererIcon", {
  enumerable: true,
  get: function get() {
    return _MidRendererIcon.default;
  }
});
Object.defineProperty(exports, "HiFiIcon", {
  enumerable: true,
  get: function get() {
    return _HiFiIcon.default;
  }
});
Object.defineProperty(exports, "TobiIcon", {
  enumerable: true,
  get: function get() {
    return _TobiIcon.default;
  }
});
Object.defineProperty(exports, "LogoIcon", {
  enumerable: true,
  get: function get() {
    return _LogoIcon.default;
  }
});
Object.defineProperty(exports, "ThirdPartyIcon", {
  enumerable: true,
  get: function get() {
    return _ThirdPartyIcon.default;
  }
});
Object.defineProperty(exports, "ThirdPartyMonoIcon", {
  enumerable: true,
  get: function get() {
    return _ThirdPartyMonoIcon.default;
  }
});
Object.defineProperty(exports, "NotificationIcon", {
  enumerable: true,
  get: function get() {
    return _NotificationIcon.default;
  }
});
Object.defineProperty(exports, "Typography", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});
Object.defineProperty(exports, "Loader", {
  enumerable: true,
  get: function get() {
    return _Loader.default;
  }
});
Object.defineProperty(exports, "AvatarIcon", {
  enumerable: true,
  get: function get() {
    return _AvatarIcon.default;
  }
});
Object.defineProperty(exports, "AvatarLetter", {
  enumerable: true,
  get: function get() {
    return _AvatarLetter.default;
  }
});
Object.defineProperty(exports, "AvatarPhoto", {
  enumerable: true,
  get: function get() {
    return _AvatarPhoto.default;
  }
});
Object.defineProperty(exports, "AvatarTobi", {
  enumerable: true,
  get: function get() {
    return _AvatarTobi.default;
  }
});
Object.defineProperty(exports, "BadgeIcon", {
  enumerable: true,
  get: function get() {
    return _BadgeIcon.default;
  }
});
Object.defineProperty(exports, "BadgeNumber", {
  enumerable: true,
  get: function get() {
    return _BadgeNumber.default;
  }
});
Object.defineProperty(exports, "BadgeSimple", {
  enumerable: true,
  get: function get() {
    return _BadgeSimple.default;
  }
});
Object.defineProperty(exports, "BadgeText", {
  enumerable: true,
  get: function get() {
    return _BadgeText.default;
  }
});
Object.defineProperty(exports, "ButtonDefault", {
  enumerable: true,
  get: function get() {
    return _ButtonDefault.default;
  }
});
Object.defineProperty(exports, "ButtonFloating", {
  enumerable: true,
  get: function get() {
    return _ButtonFloating.default;
  }
});
Object.defineProperty(exports, "ButtonIcon", {
  enumerable: true,
  get: function get() {
    return _ButtonIcon.default;
  }
});
Object.defineProperty(exports, "ButtonText", {
  enumerable: true,
  get: function get() {
    return _ButtonText.default;
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});
Object.defineProperty(exports, "Favourite", {
  enumerable: true,
  get: function get() {
    return _Favourite.default;
  }
});
Object.defineProperty(exports, "Radio", {
  enumerable: true,
  get: function get() {
    return _Radio.default;
  }
});
Object.defineProperty(exports, "Toggle", {
  enumerable: true,
  get: function get() {
    return _Toggle.default;
  }
});
Object.defineProperty(exports, "Arch", {
  enumerable: true,
  get: function get() {
    return _Arch.default;
  }
});
Object.defineProperty(exports, "Bar", {
  enumerable: true,
  get: function get() {
    return _Bar.default;
  }
});
Object.defineProperty(exports, "Dial", {
  enumerable: true,
  get: function get() {
    return _Dial.default;
  }
});
Object.defineProperty(exports, "Divider", {
  enumerable: true,
  get: function get() {
    return _Divider.default;
  }
});
Object.defineProperty(exports, "Filter", {
  enumerable: true,
  get: function get() {
    return _Filter.default;
  }
});
Object.defineProperty(exports, "Gallery", {
  enumerable: true,
  get: function get() {
    return _Gallery.default;
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _Image.default;
  }
});
Object.defineProperty(exports, "Alert", {
  enumerable: true,
  get: function get() {
    return _Alert.default;
  }
});
Object.defineProperty(exports, "OtpInput", {
  enumerable: true,
  get: function get() {
    return _OtpInput.default;
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _Search.default;
  }
});
Object.defineProperty(exports, "TextField", {
  enumerable: true,
  get: function get() {
    return _TextField.default;
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});
Object.defineProperty(exports, "ListContainer", {
  enumerable: true,
  get: function get() {
    return _ListContainer.default;
  }
});
Object.defineProperty(exports, "ListItem", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});
Object.defineProperty(exports, "OverflowMenuContainer", {
  enumerable: true,
  get: function get() {
    return _OverflowMenuContainer.default;
  }
});
Object.defineProperty(exports, "OverflowMenuItem", {
  enumerable: true,
  get: function get() {
    return _OverflowMenuItem.default;
  }
});
Object.defineProperty(exports, "PickerCalendar", {
  enumerable: true,
  get: function get() {
    return _PickerCalendar.default;
  }
});
Object.defineProperty(exports, "PickerColor", {
  enumerable: true,
  get: function get() {
    return _PickerColor.default;
  }
});
Object.defineProperty(exports, "PickerStandard", {
  enumerable: true,
  get: function get() {
    return _PickerSandard.default;
  }
});
Object.defineProperty(exports, "PickerContainer", {
  enumerable: true,
  get: function get() {
    return _PickerContainer.default;
  }
});
Object.defineProperty(exports, "PickerDay", {
  enumerable: true,
  get: function get() {
    return _PickerDay.default;
  }
});
Object.defineProperty(exports, "PickerQuantity", {
  enumerable: true,
  get: function get() {
    return _PickerQuantity.default;
  }
});
Object.defineProperty(exports, "PickerSize", {
  enumerable: true,
  get: function get() {
    return _PickerSize.default;
  }
});
Object.defineProperty(exports, "Steps", {
  enumerable: true,
  get: function get() {
    return _Steps.default;
  }
});
Object.defineProperty(exports, "TabsGroup", {
  enumerable: true,
  get: function get() {
    return _TabsGroup.default;
  }
});
Object.defineProperty(exports, "TabsSimple", {
  enumerable: true,
  get: function get() {
    return _TabsSimple.default;
  }
});
Object.defineProperty(exports, "Tooltip", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});
Object.defineProperty(exports, "GridContainer", {
  enumerable: true,
  get: function get() {
    return _GridContainer.default;
  }
});
Object.defineProperty(exports, "GridItem", {
  enumerable: true,
  get: function get() {
    return _GridItem.default;
  }
});
Object.defineProperty(exports, "BoxContainer", {
  enumerable: true,
  get: function get() {
    return _BoxContainer.default;
  }
});
Object.defineProperty(exports, "BoxFlex", {
  enumerable: true,
  get: function get() {
    return _BoxFlex.default;
  }
});
Object.defineProperty(exports, "BoxTheme", {
  enumerable: true,
  get: function get() {
    return _BoxTheme.default;
  }
});
Object.defineProperty(exports, "BoxSizing", {
  enumerable: true,
  get: function get() {
    return _BoxSizing.default;
  }
});
Object.defineProperty(exports, "BoxPosition", {
  enumerable: true,
  get: function get() {
    return _BoxPosition.default;
  }
});
Object.defineProperty(exports, "BoxStyled", {
  enumerable: true,
  get: function get() {
    return _BoxStyled.default;
  }
});
Object.defineProperty(exports, "BoxVisibility", {
  enumerable: true,
  get: function get() {
    return _BoxVisibility.default;
  }
});
Object.defineProperty(exports, "BoxCollapse", {
  enumerable: true,
  get: function get() {
    return _BoxCollapse.default;
  }
});
Object.defineProperty(exports, "AppBar", {
  enumerable: true,
  get: function get() {
    return _AppBar.default;
  }
});
Object.defineProperty(exports, "WebBar", {
  enumerable: true,
  get: function get() {
    return _WebBar.default;
  }
});
Object.defineProperty(exports, "CardContainer", {
  enumerable: true,
  get: function get() {
    return _CardContainer.default;
  }
});
Object.defineProperty(exports, "CardContent", {
  enumerable: true,
  get: function get() {
    return _CardContent.default;
  }
});
Object.defineProperty(exports, "CardAction", {
  enumerable: true,
  get: function get() {
    return _CardAction.default;
  }
});
Object.defineProperty(exports, "CardMessages", {
  enumerable: true,
  get: function get() {
    return _CardMessages.default;
  }
});
Object.defineProperty(exports, "CardPromotional", {
  enumerable: true,
  get: function get() {
    return _CardPromotional.default;
  }
});
Object.defineProperty(exports, "CardRewards", {
  enumerable: true,
  get: function get() {
    return _CardRewards.default;
  }
});
Object.defineProperty(exports, "CardCollapse", {
  enumerable: true,
  get: function get() {
    return _CardCollapse.default;
  }
});
Object.defineProperty(exports, "CardChat", {
  enumerable: true,
  get: function get() {
    return _CardChat.default;
  }
});
Object.defineProperty(exports, "CardProduct", {
  enumerable: true,
  get: function get() {
    return _CardProduct.default;
  }
});
Object.defineProperty(exports, "CardsDiscovery", {
  enumerable: true,
  get: function get() {
    return _CardsDiscovery.default;
  }
});
Object.defineProperty(exports, "BlocksHero", {
  enumerable: true,
  get: function get() {
    return _BlocksHero.default;
  }
});
Object.defineProperty(exports, "BlocksHeroCarousel", {
  enumerable: true,
  get: function get() {
    return _BlocksHeroCarousel.default;
  }
});
Object.defineProperty(exports, "DialogFullWidth", {
  enumerable: true,
  get: function get() {
    return _DialogFullWidth.default;
  }
});
Object.defineProperty(exports, "DialogDefault", {
  enumerable: true,
  get: function get() {
    return _DialogDefault.default;
  }
});
exports.default = void 0;

var _Breadcrumbs = _interopRequireDefault(require("@material-ui/core/Breadcrumbs"));

var _AppTheme = _interopRequireDefault(require("../AppTheme"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _package = _interopRequireDefault(require("../../package.json"));

var _SystemIcon = _interopRequireDefault(require("./protons/icons/SystemIcon"));

var _SystemIconSchema = _interopRequireDefault(require("./protons/icons/SystemIcon.schema.json"));

var _MidRendererIcon = _interopRequireDefault(require("./protons/icons/MidRendererIcon"));

var _MidRendererIconSchema = _interopRequireDefault(require("./protons/icons/MidRendererIcon.schema.json"));

var _HiFiIcon = _interopRequireDefault(require("./protons/icons/HiFiIcon"));

var _HiFiIconSchema = _interopRequireDefault(require("./protons/icons/HiFiIcon.schema.json"));

var _TobiIcon = _interopRequireDefault(require("./protons/icons/TobiIcon"));

var _TobiIconSchema = _interopRequireDefault(require("./protons/icons/TobiIcon.schema.json"));

var _LogoIcon = _interopRequireDefault(require("./protons/icons/LogoIcon"));

var _LogoIconSchema = _interopRequireDefault(require("./protons/icons/LogoIcon.schema.json"));

var _ThirdPartyIcon = _interopRequireDefault(require("./protons/icons/ThirdPartyIcon"));

var _ThirdPartyIconSchema = _interopRequireDefault(require("./protons/icons/ThirdPartyIcon.schema.json"));

var _ThirdPartyMonoIcon = _interopRequireDefault(require("./protons/icons/ThirdPartyMonoIcon"));

var _ThirdPartyMonoIconSchema = _interopRequireDefault(require("./protons/icons/ThirdPartyMonoIcon.schema.json"));

var _NotificationIcon = _interopRequireDefault(require("./protons/icons/NotificationIcon"));

var _NotificationIconSchema = _interopRequireDefault(require("./protons/icons/NotificationIcon.schema.json"));

var _Typography = _interopRequireDefault(require("./protons/typography/Typography"));

var _TypographySchema = _interopRequireDefault(require("./protons/typography/Typography.schema.json"));

var _Heading = _interopRequireDefault(require("./protons/typography/heading/Heading"));

var _HeadingSchema = _interopRequireDefault(require("./protons/typography/heading/Heading.schema.json"));

var _Paragraph = _interopRequireDefault(require("./protons/typography/paragraph/Paragraph"));

var _ParagraphSchema = _interopRequireDefault(require("./protons/typography/paragraph/Paragraph.schema.json"));

var _Span = _interopRequireDefault(require("./protons/typography/span/Span"));

var _SpanSchema = _interopRequireDefault(require("./protons/typography/span/Span.schema.json"));

var _Loader = _interopRequireDefault(require("./atoms/loader/Loader"));

var _LoaderSchema = _interopRequireDefault(require("./atoms/loader/Loader.schema.json"));

var _AvatarIcon = _interopRequireDefault(require("./atoms/avatars/avatarIcon/AvatarIcon"));

var _AvatarIconSchema = _interopRequireDefault(require("./atoms/avatars/avatarIcon/AvatarIcon.schema.json"));

var _AvatarLetter = _interopRequireDefault(require("./atoms/avatars/avatarLetter/AvatarLetter"));

var _AvatarLetterSchema = _interopRequireDefault(require("./atoms/avatars/avatarLetter/AvatarLetter.schema.json"));

var _AvatarPhoto = _interopRequireDefault(require("./atoms/avatars/avatarPhoto/AvatarPhoto"));

var _AvatarPhotoSchema = _interopRequireDefault(require("./atoms/avatars/avatarPhoto/AvatarPhoto.schema.json"));

var _AvatarTobi = _interopRequireDefault(require("./atoms/avatars/avatarTobi/AvatarTobi"));

var _AvatarTobiSchema = _interopRequireDefault(require("./atoms/avatars/avatarTobi/AvatarTobi.schema.json"));

var _BadgeIcon = _interopRequireDefault(require("./atoms/badges/badgeIcon/BadgeIcon"));

var _BadgeIconSchema = _interopRequireDefault(require("./atoms/badges/badgeIcon/BadgeIcon.schema.json"));

var _BadgeNumber = _interopRequireDefault(require("./atoms/badges/badgeNumber/BadgeNumber"));

var _BadgeNumberSchema = _interopRequireDefault(require("./atoms/badges/badgeNumber/BadgeNumber.schema.json"));

var _BadgeSimple = _interopRequireDefault(require("./atoms/badges/badgeSimple/BadgeSimple"));

var _BadgeSimpleSchema = _interopRequireDefault(require("./atoms/badges/badgeSimple/BadgeSimple.schema.json"));

var _BadgeText = _interopRequireDefault(require("./atoms/badges/badgeText/BadgeText"));

var _BadgeTextSchema = _interopRequireDefault(require("./atoms/badges/badgeText/BadgeText.schema.json"));

var _ButtonDefault = _interopRequireDefault(require("./atoms/buttons/button/ButtonDefault"));

var _ButtonDefaultSchema = _interopRequireDefault(require("./atoms/buttons/button/ButtonDefault.schema.json"));

var _ButtonFloating = _interopRequireDefault(require("./atoms/buttons/buttonFloating/ButtonFloating"));

var _ButtonFloatingSchema = _interopRequireDefault(require("./atoms/buttons/buttonFloating/ButtonFloating.schema.json"));

var _ButtonIcon = _interopRequireDefault(require("./atoms/buttons/buttonIcon/ButtonIcon"));

var _ButtonIconSchema = _interopRequireDefault(require("./atoms/buttons/buttonIcon/ButtonIcon.schema.json"));

var _ButtonText = _interopRequireDefault(require("./atoms/buttons/buttonText/ButtonText"));

var _ButtonTextSchema = _interopRequireDefault(require("./atoms/buttons/buttonText/ButtonText.schema.json"));

var _Checkbox = _interopRequireDefault(require("./atoms/controls/checkbox/Checkbox"));

var _CheckboxSchema = _interopRequireDefault(require("./atoms/controls/checkbox/Checkbox.schema.json"));

var _Favourite = _interopRequireDefault(require("./atoms/controls/favourite/Favourite"));

var _FavouriteSchema = _interopRequireDefault(require("./atoms/controls/favourite/Favourite.schema.json"));

var _Radio = _interopRequireDefault(require("./atoms/controls/radio/Radio"));

var _RadioSchema = _interopRequireDefault(require("./atoms/controls/radio/Radio.schema.json"));

var _Toggle = _interopRequireDefault(require("./atoms/controls/toggle/Toggle"));

var _ToggleSchema = _interopRequireDefault(require("./atoms/controls/toggle/Toggle.schema.json"));

var _Arch = _interopRequireDefault(require("./atoms/dataVisual/arch/Arch"));

var _ArchSchema = _interopRequireDefault(require("./atoms/dataVisual/arch/Arch.schema.json"));

var _Bar = _interopRequireDefault(require("./atoms/dataVisual/bar/Bar"));

var _BarSchema = _interopRequireDefault(require("./atoms/dataVisual/bar/Bar.schema.json"));

var _Dial = _interopRequireDefault(require("./atoms/dataVisual/dial/Dial"));

var _DialSchema = _interopRequireDefault(require("./atoms/dataVisual/dial/Dial.schema.json"));

var _Divider = _interopRequireDefault(require("./atoms/dividers/Divider"));

var _DividerSchema = _interopRequireDefault(require("./atoms/dividers/Divider.schema.json"));

var _Filter = _interopRequireDefault(require("./atoms/filter/Filter"));

var _FilterSchema = _interopRequireDefault(require("./atoms/filter/Filter.schema.json"));

var _Gallery = _interopRequireDefault(require("./atoms/images/gallery/Gallery"));

var _GallerySchema = _interopRequireDefault(require("./atoms/images/gallery/Gallery.schema.json"));

var _Image = _interopRequireDefault(require("./atoms/images/image/Image"));

var _ImageSchema = _interopRequireDefault(require("./atoms/images/image/Image.schema.json"));

var _Alert = _interopRequireDefault(require("./molecules/alerts/Alert"));

var _AlertSchema = _interopRequireDefault(require("./molecules/alerts/Alert.schema.json"));

var _BreadcrumbsSchema = _interopRequireDefault(require("./molecules/breadcrumbs/Breadcrumbs.schema.json"));

var _OtpInput = _interopRequireDefault(require("./molecules/inputs/OtpInput/OtpInput"));

var _OtpInputSchema = _interopRequireDefault(require("./molecules/inputs/OtpInput/OtpInput.schema.json"));

var _Search = _interopRequireDefault(require("./molecules/inputs/search/Search"));

var _SearchSchema = _interopRequireDefault(require("./molecules/inputs/search/Search.schema.json"));

var _TextField = _interopRequireDefault(require("./molecules/inputs/textField/TextField"));

var _TextFieldSchema = _interopRequireDefault(require("./molecules/inputs/textField/TextField.schema.json"));

var _Select = _interopRequireDefault(require("./molecules/inputs/select/Select"));

var _SelectSchema = _interopRequireDefault(require("./molecules/inputs/select/Select.schema.json"));

var _ListContainer = _interopRequireDefault(require("./molecules/lists/ListContainer"));

var _ListContainerSchema = _interopRequireDefault(require("./molecules/lists/ListContainer.schema.json"));

var _ListItem = _interopRequireDefault(require("./molecules/lists/ListItem"));

var _ListItemSchema = _interopRequireDefault(require("./molecules/lists/ListItem.schema.json"));

var _OverflowMenu = _interopRequireDefault(require("./molecules/overflowMenu/OverflowMenu"));

var _OverflowMenuSchema = _interopRequireDefault(require("./molecules/overflowMenu/OverflowMenu.schema.json"));

var _OverflowMenuContainer = _interopRequireDefault(require("./molecules/overflowMenu/OverflowMenuContainer"));

var _OverflowMenuContainerSchema = _interopRequireDefault(require("./molecules/overflowMenu/OverflowMenuContainer.schema.json"));

var _OverflowMenuItem = _interopRequireDefault(require("./molecules/overflowMenu/OverflowMenuItem"));

var _OverflowMenuItemSchema = _interopRequireDefault(require("./molecules/overflowMenu/OverflowMenuItem.schema.json"));

var _PickerCalendar = _interopRequireDefault(require("./molecules/pickers/pickerCalendar/PickerCalendar"));

var _PickerCalendarSchema = _interopRequireDefault(require("./molecules/pickers/pickerCalendar/PickerCalendar.schema.json"));

var _PickerColor = _interopRequireDefault(require("./molecules/pickers/pickerColor/PickerColor"));

var _PickerColorSchema = _interopRequireDefault(require("./molecules/pickers/pickerColor/PickerColor.schema.json"));

var _PickerSandard = _interopRequireDefault(require("./molecules/pickers/pickerStandard/PickerSandard"));

var _PickerStandardSchema = _interopRequireDefault(require("./molecules/pickers/pickerStandard/PickerStandard.schema.json"));

var _PickerContainer = _interopRequireDefault(require("./molecules/pickers/pickerContainer/PickerContainer"));

var _PickerContainerSchema = _interopRequireDefault(require("./molecules/pickers/pickerContainer/PickerContainer.schema.json"));

var _PickerDay = _interopRequireDefault(require("./molecules/pickers/pickerDay/PickerDay"));

var _PickerDaySchema = _interopRequireDefault(require("./molecules/pickers/pickerDay/PickerDay.schema.json"));

var _PickerQuantity = _interopRequireDefault(require("./molecules/pickers/pickerQuantity/PickerQuantity"));

var _PickerQuantitySchema = _interopRequireDefault(require("./molecules/pickers/pickerQuantity/PickerQuantity.schema.json"));

var _PickerSize = _interopRequireDefault(require("./molecules/pickers/pickerSize/PickerSize"));

var _PickerSizeSchema = _interopRequireDefault(require("./molecules/pickers/pickerSize/PickerSize.schema.json"));

var _Steps = _interopRequireDefault(require("./molecules/stepper/Steps"));

var _StepsSchema = _interopRequireDefault(require("./molecules/stepper/Steps.schema.json"));

var _TabsGroup = _interopRequireDefault(require("./molecules/tabs/tabsGroup/TabsGroup"));

var _TabsGroupSchema = _interopRequireDefault(require("./molecules/tabs/tabsGroup/TabsGroup.schema.json"));

var _TabsSimple = _interopRequireDefault(require("./molecules/tabs/tabsSimple/TabsSimple"));

var _TabsSimpleSchema = _interopRequireDefault(require("./molecules/tabs/tabsSimple/TabsSimple.schema.json"));

var _Tabs = _interopRequireDefault(require("./molecules/tabs/Tabs"));

var _TabsSchema = _interopRequireDefault(require("./molecules/tabs/Tabs.schema.json"));

var _TabSchema = _interopRequireDefault(require("./molecules/tabs/Tab.schema.json"));

var _Tooltip = _interopRequireDefault(require("./molecules/tooltip/Tooltip"));

var _TooltipSchema = _interopRequireDefault(require("./molecules/tooltip/Tooltip.schema.json"));

var _GridContainer = _interopRequireDefault(require("./layouts/grid/GridContainer"));

var _GridContainerSchema = _interopRequireDefault(require("./layouts/grid/GridContainer.schema.json"));

var _GridItem = _interopRequireDefault(require("./layouts/grid/GridItem"));

var _GridItemSchema = _interopRequireDefault(require("./layouts/grid/GridItem.schema.json"));

var _BoxContainer = _interopRequireDefault(require("./layouts/box/boxContainer/BoxContainer"));

var _BoxContainerSchema = _interopRequireDefault(require("./layouts/box/boxContainer/BoxContainer.schema.json"));

var _BoxFlex = _interopRequireDefault(require("./layouts/box/boxFlex/BoxFlex"));

var _BoxFlexSchema = _interopRequireDefault(require("./layouts/box/boxFlex/BoxFlex.schema.json"));

var _BoxTheme = _interopRequireDefault(require("./layouts/box/boxTheme/BoxTheme"));

var _BoxThemeSchema = _interopRequireDefault(require("./layouts/box/boxTheme/BoxTheme.schema.json"));

var _BoxSizing = _interopRequireDefault(require("./layouts/box/boxSizing/BoxSizing"));

var _BoxSizingSchema = _interopRequireDefault(require("./layouts/box/boxSizing/BoxSizing.schema.json"));

var _BoxPosition = _interopRequireDefault(require("./layouts/box/boxPosition/BoxPosition"));

var _BoxPositionSchema = _interopRequireDefault(require("./layouts/box/boxPosition/BoxPosition.schema.json"));

var _BoxStyled = _interopRequireDefault(require("./layouts/box/boxStyled/BoxStyled"));

var _BoxStyledSchema = _interopRequireDefault(require("./layouts/box/boxStyled/BoxStyled.schema.json"));

var _BoxVisibility = _interopRequireDefault(require("./layouts/box/boxVisibility/BoxVisibility"));

var _BoxVisibilitySchema = _interopRequireDefault(require("./layouts/box/boxVisibility/BoxVisibility.schema.json"));

var _BoxCollapse = _interopRequireDefault(require("./layouts/box/boxCollapse/BoxCollapse"));

var _BoxCollapseSchema = _interopRequireDefault(require("./layouts/box/boxCollapse/BoxCollapse.schema.json"));

var _AppBar = _interopRequireDefault(require("./organisms/appBar/AppBar"));

var _AppBarSchema = _interopRequireDefault(require("./organisms/appBar/AppBar.schema.json"));

var _WebBar = _interopRequireDefault(require("./organisms/webbar/WebBar"));

var _WebBarSchema = _interopRequireDefault(require("./organisms/webbar/WebBar.schema.json"));

var _CardContainer = _interopRequireDefault(require("./organisms/cards/cardContainer/CardContainer"));

var _CardContainerSchema = _interopRequireDefault(require("./organisms/cards/cardContainer/CardContainer.schema.json"));

var _CardContent = _interopRequireDefault(require("./organisms/cards/cardContainer/CardContent"));

var _CardContentSchema = _interopRequireDefault(require("./organisms/cards/cardContainer/CardContent.schema.json"));

var _CardAction = _interopRequireDefault(require("./organisms/cards/cardContainer/CardAction"));

var _CardActionSchema = _interopRequireDefault(require("./organisms/cards/cardContainer/CardAction.schema.json"));

var _CardMessages = _interopRequireDefault(require("./organisms/cards/cardMessages/CardMessages"));

var _CardMessagesSchema = _interopRequireDefault(require("./organisms/cards/cardMessages/CardMessages.schema.json"));

var _CardPromotional = _interopRequireDefault(require("./organisms/cards/cardPromotional/CardPromotional"));

var _CardPromotionalSchema = _interopRequireDefault(require("./organisms/cards/cardPromotional/CardPromotional.schema.json"));

var _CardRewards = _interopRequireDefault(require("./organisms/cards/cardRewards/CardRewards"));

var _CardRewardsSchema = _interopRequireDefault(require("./organisms/cards/cardRewards/CardRewards.schema.json"));

var _CardCollapse = _interopRequireDefault(require("./organisms/cards/cardCollapse/CardCollapse"));

var _CardCollapseSchema = _interopRequireDefault(require("./organisms/cards/cardCollapse/CardCollapse.schema.json"));

var _CardChat = _interopRequireDefault(require("./organisms/cards/cardChat/CardChat"));

var _CardChatSchema = _interopRequireDefault(require("./organisms/cards/cardChat/CardChat.schema.json"));

var _CardProduct = _interopRequireDefault(require("./organisms/cards/cardProduct/CardProduct"));

var _CardProductSchema = _interopRequireDefault(require("./organisms/cards/cardProduct/CardProduct.schema.json"));

var _CardsDiscovery = _interopRequireDefault(require("./organisms/cards/cardsDiscovery/CardsDiscovery"));

var _CardsDiscoverySchema = _interopRequireDefault(require("./organisms/cards/cardsDiscovery/CardsDiscovery.schema.json"));

var _BlocksHero = _interopRequireDefault(require("./organisms/blocks/blocksHero/BlocksHero"));

var _BlocksHeroSchema = _interopRequireDefault(require("./organisms/blocks/blocksHero/BlocksHero.schema.json"));

var _BlocksHeroCarousel = _interopRequireDefault(require("./organisms/blocks/blocksHeroCarousel/BlocksHeroCarousel"));

var _BlocksHeroCarouselSchema = _interopRequireDefault(require("./organisms/blocks/blocksHeroCarousel/BlocksHeroCarousel.schema.json"));

var _DialogFullWidth = _interopRequireDefault(require("./organisms/dialog/dialogFullWidth/DialogFullWidth"));

var _DialogFullWidthSchema = _interopRequireDefault(require("./organisms/dialog/dialogFullWidth/DialogFullWidth.schema.json"));

var _DialogDefault = _interopRequireDefault(require("./organisms/dialog/DialogDefault/DialogDefault"));

var _DialogDefaultSchema = _interopRequireDefault(require("./organisms/dialog/DialogDefault/DialogDefault.schema.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// -----------------------------------  Protons -----------------------------------
// Icons
// -----------------------------------  Atoms -----------------------------------
// Loader
// Avatars
// Badges
// Buttons
// Controls
// Data Visual
// Divider
// Filter
// Images
// ----------------------------------- Molecules -----------------------------------
// Alerts
// Breadcrumbs
// Inputs
// Lists
// Overflow menu
// Pickers
// Stepper
// Tabs
// Tooltip
// ----------------------------------- Molecules -----------------------------------
// ----------------------------------- Layouts -----------------------------------
// Grid
// Box
// ----------------------------------- Organisms -----------------------------------
// Cards
// BLocks
// Dialog
// DialogDefault
// ----------------------------------- Organisms -----------------------------------
var a = function a(name, component, propsSchema) {
  return {
    _id: "Atoms-".concat(name),
    name: name,
    version: _package.default.version,
    component: component,
    propsSchema: propsSchema,
    author: _package.default.author || "vfteam",
    description: name,
    images: [],
    appFramework: {
      "widget-category": "Atomics",
      theme: ["MVA10"],
      author: "vfteam",
      description: name
    }
  };
};

var _default = [{
  _id: "Protons",
  widgets: [a("SystemIcon", _SystemIcon.default, _SystemIconSchema.default), a("MidRendererIcon", _MidRendererIcon.default, _MidRendererIconSchema.default), a("HiFiIcon", _HiFiIcon.default, _HiFiIconSchema.default), a("TobiIcon", _TobiIcon.default, _TobiIconSchema.default), a("LogoIcon", _LogoIcon.default, _LogoIconSchema.default), a("ThirdPartyIcon", _ThirdPartyIcon.default, _ThirdPartyIconSchema.default), a("ThirdPartyMonoIcon", _ThirdPartyMonoIcon.default, _ThirdPartyMonoIconSchema.default), a("NotificationIcon", _NotificationIcon.default, _NotificationIconSchema.default), a("Typography", _Typography.default, _TypographySchema.default), a("Heading", _Heading.default, _HeadingSchema.default), a("Paragraph", _Paragraph.default, _ParagraphSchema.default), a("Span", _Span.default, _SpanSchema.default)]
}, {
  _id: "Atoms",
  widgets: [a("Loader", _Loader.default, _LoaderSchema.default), a("AvatarIcon", _AvatarIcon.default, _AvatarIconSchema.default), a("AvatarLetter", _AvatarLetter.default, _AvatarLetterSchema.default), a("AvatarPhoto", _AvatarPhoto.default, _AvatarPhotoSchema.default), a("AvatarTobi", _AvatarTobi.default, _AvatarTobiSchema.default), a("BadgeIcon", _BadgeIcon.default, _BadgeIconSchema.default), a("BadgeNumber", _BadgeNumber.default, _BadgeNumberSchema.default), a("BadgeSimple", _BadgeSimple.default, _BadgeSimpleSchema.default), a("BadgeText", _BadgeText.default, _BadgeTextSchema.default), a("ButtonDefault", _ButtonDefault.default, _ButtonDefaultSchema.default), a("ButtonFloating", _ButtonFloating.default, _ButtonFloatingSchema.default), a("ButtonIcon", _ButtonIcon.default, _ButtonIconSchema.default), a("ButtonText", _ButtonText.default, _ButtonTextSchema.default), a("Checkbox", _Checkbox.default, _CheckboxSchema.default), a("Radio", _Radio.default, _RadioSchema.default), a("Toggle", _Toggle.default, _ToggleSchema.default), a("Favourite", _Favourite.default, _FavouriteSchema.default), a("Arch", _Arch.default, _ArchSchema.default), a("Bar", _Bar.default, _BarSchema.default), a("Dial", _Dial.default, _DialSchema.default), a("Divider", _Divider.default, _DividerSchema.default), a("Filter", _Filter.default, _FilterSchema.default), a("Gallery", _Gallery.default, _GallerySchema.default), a("Image", _Image.default, _ImageSchema.default)]
}, {
  _id: "Molecules",
  widgets: [a("Alert", _Alert.default, _AlertSchema.default), a("Breadcrumbs", _Breadcrumbs.default, _BreadcrumbsSchema.default), a("OtpInput", _OtpInput.default, _OtpInputSchema.default), a("Search", _Search.default, _SearchSchema.default), a("TextField", _TextField.default, _TextFieldSchema.default), a("Select", _Select.default, _SelectSchema.default), a("ListContainer", _ListContainer.default, _ListContainerSchema.default), a("ListItem", _ListItem.default, _ListItemSchema.default), a("OverflowMenu", _OverflowMenu.default, _OverflowMenuSchema.default), a("OverflowMenuContainer", _OverflowMenuContainer.default, _OverflowMenuContainerSchema.default), a("OverflowMenuItem", _OverflowMenuItem.default, _OverflowMenuItemSchema.default), a("PickerCalendar", _PickerCalendar.default, _PickerCalendarSchema.default), a("PickerColor", _PickerColor.default, _PickerColorSchema.default), a("PickerStandard", _PickerSandard.default, _PickerStandardSchema.default), a("PickerContainer", _PickerContainer.default, _PickerContainerSchema.default), a("PickerDay", _PickerDay.default, _PickerDaySchema.default), a("PickerQuantity", _PickerQuantity.default, _PickerQuantitySchema.default), a("PickerSize", _PickerSize.default, _PickerSizeSchema.default), a("Steps", _Steps.default, _StepsSchema.default), a("Tabs", _Tabs.default, _TabsSchema.default), a("Tab", _Tab.default, _TabSchema.default), a("TabsSimple", _TabsSimple.default, _TabsSimpleSchema.default), a("TabsGroup", _TabsGroup.default, _TabsGroupSchema.default), a("Tooltip", _Tooltip.default, _TooltipSchema.default)]
}, {
  _id: "Layouts",
  widgets: [a("BoxFlex", _BoxFlex.default, _BoxFlexSchema.default), a("BoxTheme", _BoxTheme.default, _BoxThemeSchema.default), a("BoxContainer", _BoxContainer.default, _BoxContainerSchema.default), a("BoxSizing", _BoxSizing.default, _BoxSizingSchema.default), a("BoxPosition", _BoxPosition.default, _BoxPositionSchema.default), a("BoxStyled", _BoxStyled.default, _BoxStyledSchema.default), a("BoxVisibility", _BoxVisibility.default, _BoxVisibilitySchema.default), a("BoxCollapse", _BoxCollapse.default, _BoxCollapseSchema.default), a("GridContainer", _GridContainer.default, _GridContainerSchema.default), a("GridItem", _GridItem.default, _GridItemSchema.default)]
}, {
  _id: "Templates",
  widgets: []
}, {
  _id: "Organisms",
  widgets: [a("WebBar", _WebBar.default, _WebBarSchema.default), a("AppBar", _AppBar.default, _AppBarSchema.default), a("CardContainer", _CardContainer.default, _CardContainerSchema.default), a("CardContent", _CardContent.default, _CardContentSchema.default), a("CardMessages", _CardMessages.default, _CardMessagesSchema.default), a("CardAction", _CardAction.default, _CardActionSchema.default), a("CardPromotional", _CardPromotional.default, _CardPromotionalSchema.default), a("CardRewards", _CardRewards.default, _CardRewardsSchema.default), a("CardCollapse", _CardCollapse.default, _CardCollapseSchema.default), a("CardChat", _CardChat.default, _CardChatSchema.default), a("CardProduct", _CardProduct.default, _CardProductSchema.default), a("CardsDiscovery", _CardsDiscovery.default, _CardsDiscoverySchema.default), a("BlocksHero", _BlocksHero.default, _BlocksHeroSchema.default), a("BlocksHeroCarousel", _BlocksHeroCarousel.default, _BlocksHeroCarouselSchema.default), a("DialogFullWidth", _DialogFullWidth.default, _DialogFullWidthSchema.default), a("DialogDefault", _DialogDefault.default, _DialogDefaultSchema.default)]
}];
exports.default = _default;